import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "AG_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#AG_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0h32v24H0V0z",
      fill: "#1B1B1B"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16 14l-2.003 3.8.05-4.196-3.658 2.65 2.093-3.76-4.59.977 3.72-2.58L7 10l4.613-.89L7.89 6.529l4.59.977-2.092-3.76 3.659 2.65-.05-4.195L16 6l2.003-3.8-.05 4.196 3.658-2.65-2.093 3.76 4.59-.977-3.72 2.58L25 10l-4.613.89 3.722 2.581-4.59-.977 2.092 3.76-3.659-2.65.05 4.195L16 14z",
      fill: "#F9D313"
    }
  ), /* @__PURE__ */ e.createElement("path", { fill: "#F1F9FF", d: "M6 14h20v10H6z" }), /* @__PURE__ */ e.createElement("path", { fill: "#4A80E8", d: "M2 10h28v4H2z" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 6l16 18L32 6v18H0V6z",
      fill: "#E31D1C"
    }
  ))
);
export {
  t as default
};
